module.exports = {
    props: ['team', 'invitations'],


    mounted() {
        $(".copy-to-clipboard").tooltip();
    },
    methods: {
        /**
         * Cancel the sent invitation.
         */
        cancel(invitation) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            axios.delete(`/settings/invitations/${invitation.id}`)
                .then((response) => {
                    if(response.status) {
                        Toast.fire({
                            type: 'success',
                            title: 'Invitation deleted.'
                        });
                        this.$parent.$emit('updateInvitations');
                    }else{
                        Toast.fire({
                            type: 'error',
                            title: 'Unable to delete invitation.'
                        });
                    }
                });
        },
        copyToClipBoard(invitation, index) {
            let $temp = $("<input>");
            $("body").append($temp);
            if(invitation.is_pending_invite){
                $temp.val(route('register.pending')+ '?invitation='+invitation.token).select();
            }else{
                $temp.val(route('register')+ '?invitation='+invitation.token).select();
            }
            document.execCommand("copy");
            $temp.remove();
            $('.link-copied-'+index).show(300);
            setTimeout(()=>{
                $('.link-copied-'+index).hide(300);
            }, 3000);
        }
    }
};
